import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { getAppVersion } from '../../utils/sessionStorage'

export const StabilityScoreHelpContent = ({ onDismiss }: { onDismiss: () => void }) => {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        ScreenName: 'MF_L2_Elite',
        eventId: 'Stability_Score'
      }
    })
  }, [])
  return (
    <BottomSheetContent
      logoSrc='/images/mf-l2/stability-score-bottom-sheet.svg'
      heading={`${getAppVersion() >= 47 ? 'Volatility Score' : 'Stability Score'}`}
      onDismiss={onDismiss}
    >
      <div className='text-[#6A6E6E] text-[14px] font-[400]'>
        Shows how <span className='text-[#232323] text-[14px] font-[500]'> steady or volatile </span> a fund’s returns
        have been over time. <br />
        <br /> If two funds gave similar returns, the one with a higher{' '}
        {getAppVersion() >= 47 ? 'Volatility Score' : 'Stability Score'} had fewer ups and downs. <br />
        <br /> Use this to assess how{' '}
        <span className='text-[#232323] text-[14px] font-[500]'> predictable and less stressful </span> a fund is to
        hold during market swings.
      </div>
    </BottomSheetContent>
  )
}
